module.exports = __webpack_public_path__ + "static/media/44566978_2199903556751490_1109054710100262912_o-thumb.a0bf315c.jpg";